import {
  Button,
  FormControl,
  InputLabel,
  makeStyles,
  Select,
  TextField,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useAsignatures } from '../asginatures/Asignatures';
import { useGrades } from '../grades/Grades';

const useStyles = makeStyles((theme) => ({
  input: {
    marginTop: '20px',
  },
}));

function useForm(e) {
  const [entries, setEntries] = useState([]);
  const { id } = useParams();

  useEffect(() => {
    fetch(`https://api.edicionesmilenio.com/api/resources/${id}`)
      .then((response) => response.json())
      .then((data) => {
        if (data?.data) {
          setEntries(data?.data);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  function handleChange(e) {
    let { name, value } = e.target;
    if (value.includes('{') && value.includes('}')) {
      value = JSON.parse(value);
    }

    const resourceTypeAssociations = {
      video: 'Single',
      imagen: 'Single',
      audio: 'Single',
      pdf: 'Single',
      imagenes: 'Multiple',
      pdfi: 'Multiple',
    };

    if (name === 'resourceType') {
      setEntries({ ...entries, resourceType: resourceTypeAssociations[value] });
    } else {
      setEntries({ ...entries, [name]: value });
    }
  }

  return {
    handleChange,
    entries,
  };
}

export function UpdateResource(props) {
  const { asignatures } = useAsignatures();
  const { grades } = useGrades();
  const { entries, handleChange } = useForm();
  const classes = useStyles();
  const navigate = useNavigate();
  const { id } = useParams();

  const handleUpdate = async () => {
    try {
      const formData = new FormData();
      formData.append('title', entries?.title);
      formData.append('description', entries?.description);
      formData.append('grade', entries?.grade?._id);
      formData.append('asignature', entries?.asignature?._id);
      formData.append('resourceType', entries?.resourceType);

      let response = await fetch(
        `https://api.edicionesmilenio.com/api/resources/${id}`,
        {
          method: 'PUT',
          body: formData,
        }
      );
      let data = await response.json();
      if (data.success === true) {
        navigate('/admin/resources', { replace: true });
      } else {
        console.error(data.message);
        window.alert('Error al actualizar el recurso, intente de nuevo');
      }
    } catch (err) {
      console.error(err);
      window.alert('Error al actualizar el recurso, intente de nuevo');
    }
  };

  return (
    <div
      style={{
        width: '100%',
        paddingLeft: '20px',
        paddingRight: '20px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <p
        style={{
          width: '100%',
          color: '#888',
          marginBottom: '50px',
          alignSelf: 'center',
          justifySelf: 'center',
          textAlign: 'center',
        }}
      >
        Estimado administrador, desde esta sección podrás crear un nuevo recurso
        para la plataforma, estos recursos corresponden a los creados por la
        editorial y estan asingados a la asingatura y grado, los tipos de
        recursos para crear son: video, audio, PDF, imagen, mapa e imágenes.
      </p>
      <div
        style={{
          width: '100%',
          paddingLeft: '20px',
          paddingRight: '20px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-asignature-label">
            Seleccione una asignatura
          </InputLabel>
          <Select
            labelId="select-asignature-label"
            id="select-asignature"
            value={entries?.asignature || ''}
            name="asignature"
            onChange={handleChange}
            label="Seleccione una asignatura"
            native
          >
            <option value="" disabled>
              <em>Seleccione una asignatura</em>
            </option>
            {asignatures?.map((asignature, index) => (
              <option value={asignature?._id}>{asignature?.name}</option>
            ))}
          </Select>
        </FormControl>
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-grade-label">Seleccione un grado</InputLabel>
          <Select
            labelId="select-grade-label"
            id="select-grade"
            value={entries?.grade || ''}
            name="grade"
            onChange={handleChange}
            label="Seleccione un grado"
            native
          >
            <option value="" disabled>
              <em>Seleccione un grado</em>
            </option>
            {grades?.map((grade, index) => (
              <option value={grade?._id}>{grade?.name}</option>
            ))}
          </Select>
        </FormControl>
        <TextField
          className={classes.input}
          label="Título"
          variant="outlined"
          name="title"
          value={entries?.title || ''}
          onChange={handleChange}
        />
        <TextField
          className={classes.input}
          label="Descripción"
          variant="outlined"
          name="description"
          value={entries?.description || ''}
          onChange={handleChange}
        />
        <FormControl variant="outlined" className={classes.input}>
          <InputLabel id="select-type-label">Tipo de recurso</InputLabel>
          <Select
            labelId="select-type-label"
            id="select-type"
            value={entries?.resourceType || ''}
            name="resourceType"
            onChange={handleChange}
            label="Tipo de recurso"
            native
          >
            <option value="" disabled>
              <em>Seleccione un tipo</em>
            </option>
            <option value="video">Video</option>
            <option value="audio">Audio</option>
            <option value="pdf">Documento PDF</option>
            <option value="imagen">Imagen</option>
            <option value="imagenes">Imagenes</option>
            <option value="pdfi">PDF Interactivo</option>
          </Select>
        </FormControl>
        <Button
          style={{ background: '#2490AF', marginTop: '20px' }}
          onClick={handleUpdate}
          variant="contained"
          color="primary"
          disabled={
            entries?.asignature === undefined ||
            entries?.grade === undefined ||
            entries?.title === undefined ||
            entries?.description === undefined ||
            entries?.resourceType === undefined
          }
        >
          Actualizar recurso
        </Button>
      </div>
    </div>
  );
}
